"use client";

import { cn } from "@/utils/utils";
import React, { useState, useRef, useEffect } from "react";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

import { ProductJson } from "@/types/Product.type";
import { PromotionDiscountType, PromotionJson } from "@/types/Promotion.type";

import Button from "@/components/ui/Button";
import StoreList from "~components/stores/StoreList";
import ShoppingBtn from "~components/cart/ShoppingBtn";
import LoadingIcon from "@/components/icons/LoadingIcon";
import WishlistBtn from "~components/wishlist/WishlistBtn";
import ProductStatus from "~components/product/ProductStatus";
import PromotionList from "~components/promotion/PromotionList";
import ButtonCompares from "~components/product/ButtonCompares";
import ProductSinglePrice from "~components/product/ProductSinglePrice";
import ProductPercentSale from "~components/product/ProductPercentSale";
import useDealthom from "@/lib/hooks/useDealthom";
import Money from "@/components/ui/Money";
import ProductErrorQuantity from "~components/product/ProductErrorQuantity";
import useGetCodePromotion from "@/lib/hooks/useGetCodePromotion";
interface ProductActionsProps {
	productVariant: ProductJson;
	isLoadProductVariant: boolean;
	className?: string;
	quantity: number;
	handleActiveVariant?: (v: ProductJson) => void;
	handlerSubQuantity: () => void;
	handlerAddQuantity: () => void;
	handleSetQuantity: (q: number) => void;
	errorQuantity?: string[];
	refetch: () => void;
}
const translate = {
	product_like: "product_like",
};
export default function ProductActions({
	productVariant,
	isLoadProductVariant,
	handleActiveVariant,
	handlerSubQuantity,
	handlerAddQuantity,
	handleSetQuantity,
	quantity,
	className,
	errorQuantity,
	refetch,
}: ProductActionsProps) {
	const { t } = useTranslationApi(Object.values(translate));

	const { promotionsHaveConfig } = useDealthom(productVariant);

	const [isOutOfStock, setisOutOfStock] = useState(
		productVariant.quantity <= 0
	);

	const wishlistRef = useRef<null | HTMLDivElement>(null);

	function handlerSubQuantitys() {
		handlerSubQuantity();
	}

	function handlerAddQuantitys() {
		handlerAddQuantity();
	}
	function handleSetQuantitys(quantity: number) {
		if (quantity <= 0) {
			setisOutOfStock(true);
			return;
		}
		handleSetQuantity(quantity);
	}
	useEffect(() => {
		setisOutOfStock(productVariant.quantity <= 0);
		if (quantity > productVariant.quantity && productVariant.quantity > 0) {
			handleSetQuantity(productVariant.quantity);
		}
	}, [productVariant]);

	const isPromotions = promotionsHaveConfig.length > 0;

	if (isLoadProductVariant) {
		return (
			<div className="col-span-12 md:col-span-6 lg:col-span-2 border border-gray-300 rounded p-4 h-[300px] flex items-center justify-center ">
				<LoadingIcon />
			</div>
		);
	}
	if (productVariant.id < 1) {
		return <></>;
	}

	return (
		<div
			className={cn("w-full border border-gray-300 rounded h-fit", className)}>
			{isPromotions ? (
				<>
					{promotionsHaveConfig.map((p) => {
						return (
							<>
								{p.codes?.length ? (
									<>
										<div
											key={p.id}
											className={`bg-[#F6E9E9] px-4 py-2 m-0 cursor-pointer border-solid `}>
											<p className="uppercase text-red-500  text-lg font-bold mb-[2px]">
												{p.campaign_info.name}
											</p>

											{p.discount_type === PromotionDiscountType.PRODUCT && (
												<p className="text-red-500 text-lg mb-1">
													<Money
														className="font-bold"
														value={p.promotion_price}
													/>
												</p>
											)}
											<div>
												<span className=" text-gray-500 text-sm">
													Giảm thêm{" "}
													{p.discount_value_type === "amount" ? (
														<Money
															className="font-bold"
															value={p.discount_value}
														/>
													) : (
														<>{p.discount_value}%</>
													)}{" "}
													{p.discount_type === PromotionDiscountType.CART
														? " trên giá trị đơn hàng"
														: ""}
												</span>
											</div>
											<div className="text-gray-500 text-sm">
												<span>Nhập code </span>
												<b className="  text-sm  text-blue-main   cursor-pointer">
													{p.codes.map((code) => code.code).join(", ")}
												</b>
											</div>
										</div>
									</>
								) : (
									<>
										<div
											key={p.id}
											className={`bg-[#F6E9E9] px-4 py-2 m-0 cursor-pointer border-solid `}>
											<p className="uppercase text-red-500 text-lg font-bold mb-[2px]">
												{p.campaign_info.name}
											</p>
											<>
												{p.discount_type === PromotionDiscountType.PRODUCT && (
													<p className="text-red-500 text-lg mb-1">
														<Money
															className="font-bold"
															value={p.promotion_price}
														/>
													</p>
												)}

												<div>
													<span className=" text-gray-500 text-sm">
														Giảm thêm{" "}
														{p.discount_value_type === "amount" ? (
															<Money
																className="font-bold"
																value={p.discount_value}
															/>
														) : (
															<>
																{p.discount_value} {}%
															</>
														)}{" "}
														{p.discount_type === PromotionDiscountType.CART
															? " trên giá trị đơn hàng"
															: ""}
													</span>
												</div>
											</>
										</div>
									</>
								)}
							</>
						);
					})}
				</>
			) : null}

			<div
				className={cn("flex flex-col gap-[10px] p-4 ", {
					"pt-2": isPromotions,
					"pt-4": !isPromotions,
				})}>
				<ProductSinglePrice
					productVariant={{ ...productVariant, pricePreview: null }}
					classNamePriceCompare="text-base text-gray-400"
				/>
				<ProductPercentSale
					productVariant={{ ...productVariant, pricePreview: null }}
				/>
				<ProductStatus isOutOfStock={isOutOfStock} />
				<StoreList product={productVariant} />
				{errorQuantity?.length ? (
					<ProductErrorQuantity onClick={refetch} />
				) : (
					<ShoppingBtn
						isLoading={isLoadProductVariant}
						product={productVariant}
						quantity={quantity}
						promotions={promotionsHaveConfig}
						onAddQuantity={handlerAddQuantitys}
						onSubQuantity={handlerSubQuantitys}
						modeShowError="popup"
						isShowPopupError={true}
						isCheckInCart={false}
						setQuantity={handleSetQuantitys}
					/>
				)}

				<Button
					className="text-sm px-[14px] py-2 flex items-center justify-center gap-2"
					onClick={() => {
						if (wishlistRef && wishlistRef.current) {
							wishlistRef.current.click();
						}
					}}
					mode="dark-outline">
					<span>{t(translate.product_like)}</span>
					<WishlistBtn
						ref={wishlistRef}
						model={{
							item_id:
								productVariant.parent_id > 0
									? productVariant.parent_id
									: productVariant.id,
							item_type: 1,
							item_url: productVariant.handle,
						}}
						className="w-[20px] h-[20px] min-w-[20px]"
					/>
				</Button>
				{/* <ButtonCompares variant={productVariant} /> */}
			</div>
		</div>
	);
}
